import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Metrics } from "@/components/Metrics";
import { Testimonials } from "@/components/Testimonials";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#FAFAFA] min-h-screen" data-testid="landing-page">
      <Header />
      <Hero />
      <Marquee />
      <Services />
      <WhyChooseUs />
      <Metrics />
      <Testimonials />
      <LeadForm />
      <Footer />
    </div>
  );
}
